import { getCompanyCreationDocumentsStatus } from '../../../ShineStartVerification/libs/getCompanyCreationDocumentsStatus';
import { State } from '../../machine';
import model from '../../machine/model';
import locales from './locales';
import { GetVerificationStep } from './types';

export const getCompanyCreationDocumentsStep: GetVerificationStep = ({
  verificationData,
}) => {
  const { company } = verificationData.viewer;
  const documents = company.companyCreationDocuments || [];

  const status = getCompanyCreationDocumentsStatus({
    documents,
    isCompanyCreationSASU: company.isCompanyCreationSASU,
  });

  return {
    /**
     * For documents part of the SASU in house project experimentation,
     * any errors will be handled via Intercom for now
     * @todo LED-3244 - handle errors
     */
    errors: [],
    id: State.COMPANY_CREATION_DOCS,
    metadata: {
      event: model.events.GO_COMPANY_CREATION_DOCS(),
      // TODO(LED-3244): update to right icon
      iconName: 'company',
      label: locales.companyCreationDocs,
    },
    status,
  };
};
